import moment from 'moment';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getTimeFormat } from '../../../common/getDateAndTimeFormat';
import TimeUtils from '../../../utils/TimeUtils';
import { AccountData } from '../../../api';

type FinalDateDetailsProps = {
  time: moment.Moment;
  duration: number;
  account: AccountData;
};

const FinalDateDetails = ({ time, duration, account }: FinalDateDetailsProps) => {
  const { t } = useTranslation();
  const timeFormat = getTimeFormat(account);
  const endTime = moment(time).add(duration, 'seconds');

  return (
    <Grid sx={{ padding: '8px 12px', borderRadius: '8px', backgroundColor: 'mb.ground' }}>
      <Typography variant="body2">
        <strong dir="ltr" style={{ fontVariantNumeric: 'tabular-nums' }}>
          {time.format(timeFormat)}–{endTime.format(timeFormat)}
        </strong>
        &nbsp;({TimeUtils.formatDuration(duration, t)})
      </Typography>
    </Grid>
  );
};

export default FinalDateDetails;
